import { render, staticRenderFns } from "./SectionManagementModal.vue?vue&type=template&id=2059b0b8&scoped=true&"
import script from "./SectionManagementModal.vue?vue&type=script&lang=js&"
export * from "./SectionManagementModal.vue?vue&type=script&lang=js&"
import style0 from "./SectionManagementModal.vue?vue&type=style&index=0&id=2059b0b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2059b0b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
